import React, { useEffect, useRef, useCallback } from "react";
import { useParams } from "react-router-dom";
import { baseUrl } from "../Common/BaseUrl";
import axios from "axios";

const GraphFullScreen = ({ is_future = false }) => {
  const { firstCoin, secondCoin } = useParams(); // 👈 get values from URL
  const chartContainerRef = useRef(null);
  const tvWidgetRef = useRef(null);

  // determine theme
  const getTheme = useCallback(() => {
    return localStorage.getItem("theme") === "true" ? "light" : "dark";
  }, []);

  // update symbol
  const updateSymbol = useCallback(() => {
    if (tvWidgetRef.current) {
      const pairName = firstCoin + secondCoin;
      tvWidgetRef.current.setSymbol(pairName, "1D", () => {
        console.log("Symbol changed successfully");
      });
    }
  }, [firstCoin, secondCoin]);

  // init chart
  const initChart = useCallback(() => {
    const pairName = firstCoin + secondCoin;

    tvWidgetRef.current = new window.TradingView.widget({
      fullscreen: false,
      symbol: pairName,
      interval: "1D",
      container: chartContainerRef.current,
      height: 400,
      width: "100%",
      datafeed: new window.Datafeeds.UDFCompatibleDatafeed(`${baseUrl}/graph`),
      library_path: "/charting_library/",
      locale: "en",
      disabled_features: ["use_localstorage_for_settings"],
      enabled_features: ["study_templates"],
      charts_storage_url: "",
      charts_storage_api_version: "1.1",
      client_id: "om",
      user_id: "public_user_id",
      theme: getTheme(),
      timezone: "Asia/Kolkata",
      overrides: {
        "mainSeriesProperties.style": 1,
      },
      drawings_access: {
        type: "black",
        tools: [
          { name: "Brush" },
          { name: "Rectangle" },
        ],
      },
    });

    tvWidgetRef.current.onChartReady(() => {
      updateSymbol();
    });
  }, [firstCoin, secondCoin, getTheme, updateSymbol]);

  // check exchange (optional, kept if you need it later)
  const checkExchange = useCallback(() => {
    const Url = window.location.pathname.split("/");
    let sendCoinData = {
      firstCoin: Url[2],
      secondCoin: Url[3],
    };

    axios.post(baseUrl + "/frontapi/checkpair", sendCoinData).then((respData) => {
      const apiRespData = respData.data.data;
      if (apiRespData.pairId) {
        let sendCoinPair = { pair_id: apiRespData.pairId };
        axios.post(baseUrl + "/frontapi/checkpairexchange", sendCoinPair).then((respData) => {
          initChart();
          const apiExchangeResp = respData.data;
          if (apiExchangeResp.success === true) {
            localStorage.setItem("exType", apiExchangeResp.data.exchange);
          } else {
            localStorage.setItem("exType", "notExchange");
          }
        });
      }
    });
  }, [initChart]);

  // mount + cleanup
  useEffect(() => {
    initChart();

    return () => {
      if (tvWidgetRef.current) {
        tvWidgetRef.current.remove();
      }
    };
  }, [firstCoin, secondCoin, initChart]);

  // handle theme change
  useEffect(() => {
    if (tvWidgetRef.current) {
      tvWidgetRef.current.onChartReady(() => {
        tvWidgetRef.current.changeTheme(getTheme());
      });
    }
  }, [getTheme]);

  return <div ref={chartContainerRef} id="tv_chart_container"></div>;
};

export default GraphFullScreen;
